import { useContext } from "react";
import { ApiContext } from "../context/ApiContext";
import __ from "../utils/getContent";

const MembershipSummary = () => {
	const { data } = useContext(ApiContext);
	const { splitPayment = false } = data;

	return (
		<>
			{data?.get_membership_details?.MembershipDetails &&
				data?.get_packages?.StartStrongPackages && (
					<MembershipDetails
						data={{ ...data.get_membership_details.MembershipDetails }}
						launchPackageQuantity={data?.get_packages?.LaunchPackageQuantity}
						splitPayment={splitPayment}
					/>
				)}
		</>
	);
};
export default MembershipSummary;

/**
 * MembershipDetails component.
 */
const MembershipDetails = ({
	data,
	launchPackageQuantity,
	splitPayment = false,
}: {
	data: any;
	launchPackageQuantity: any;
	splitPayment: boolean;
}) => {
	const { Membership: membership = {}, Club: club = {} } = data;

	const joinDate = new Date().toLocaleDateString();
	const getDaysPast = () => {
		const now = new Date();
		return now.getDate() - 1;
	};

	// Format initiation fees.
	let initiationFees = membership?.InitiationFees?.toFixed(2);
	if (initiationFees && splitPayment) {
		initiationFees = (initiationFees / 2).toFixed(2); // Split initiation fees.
	}

	return (
		<div className="membership-summary flex w-full max-w-md flex-col items-center justify-center self-center">
			<table className="mb-10 w-full border-0">
				<tbody>
					{membership?.Name ? (
						<tr>
							<td className="border-0 py-2 pl-0 pr-4 text-left">
								{__("membership", "Membership")}
							</td>
							<td className="border-0 py-2 pr-0 text-right">
								{membership?.Name}
							</td>
						</tr>
					) : null}
					{club?.Name ? (
						<tr>
							<td className="border-0 py-2 pl-0 pr-4 text-left">
								{__("club_location", "Club Location")}
							</td>
							<td className="border-0 py-2 pr-0 text-right">{club.Name}</td>
						</tr>
					) : null}
					<tr>
						<td className="border-0 py-2 pl-0 pr-4 text-left">
							{__("join_date", "Join Date")}
						</td>
						<td className="border-0 py-2 pr-0 text-right">{joinDate}</td>
					</tr>

					{launchPackageQuantity ? (
						<tr>
							<td className="border-0 py-2 pb-10 pl-0 pr-4 text-left">
								{__("launch_package_quantity", "Launch Package Quantity")}
							</td>
							<td className="border-0 py-2 pb-10 pr-0 text-right">
								{launchPackageQuantity}
							</td>
						</tr>
					) : null}

					{membership?.Rate ? (
						<tr className="border-y border-black">
							<td className="border-0 py-4 pl-0 pr-2 text-left">
								<span className="block max-w-40">
									{__("due_date", "Due at the beginning of each month")}
								</span>
							</td>
							<td className="border-0 py-4 pr-0 text-right text-3xl">
								${membership.Rate?.toFixed(2)}
							</td>
						</tr>
					) : null}
					<tr>
						<td className="col-span-2 border-0 py-4 pl-0 pt-10 text-left uppercase">
							{__("due_today", "Due Today")}
						</td>
					</tr>
					{membership?.ProrateDuesPrice ? (
						<tr>
							<td className="border-0 py-2 pl-0 pr-4 text-left">
								{__("this_months_dues", "This Month's Dues")}
								{` (-${getDaysPast()} Days)`}
							</td>
							<td className="border-0 py-2 pr-0 text-right">
								${membership.ProrateDuesPrice?.toFixed(2)}
							</td>
						</tr>
					) : null}
					{initiationFees ? (
						<tr>
							<td className="border-0 py-2 pl-0 pr-4 text-left">
								{__("initiation_fee", "Initiation Fee")}
							</td>
							<td className="border-0 py-2 pr-0 text-right">
								${initiationFees}
							</td>
						</tr>
					) : null}
					{data?.SalesTax ? (
						<tr>
							<td className="border-0 py-2 pl-0 pr-4 text-left">
								{__("sales_tax", "Sales Tax")}
							</td>
							<td className="border-0 py-2 pr-0 text-right">
								${data.SalesTax?.toFixed(2)}
							</td>
						</tr>
					) : null}
				</tbody>
			</table>
		</div>
	);
};
